<template>
  <div>
    <content-loader
      :height="675"
      :width="600"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="92.7" y="115.61" rx="4" ry="4" width="169.58" height="22.61" />
      <rect x="45" y="64.43" rx="5" ry="5" width="20.74" height="408.17" />
      <rect x="63" y="150" rx="0" ry="0" width="0" height="0" />
      <rect x="01" y="151" rx="0" ry="0" width="0" height="0" />
      <rect x="79.24" y="150.13" rx="4" ry="4" width="397.72" height="22.61" />
      <rect x="311.62" y="112.04" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="74.35" y="389.4" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="205" y="391" rx="4" ry="4" width="174" height="19" />
      <rect x="85.36" y="188.22" rx="5" ry="5" width="18.3" height="114.24" />
      <rect x="113.49" y="265.6" rx="5" ry="5" width="18.3" height="114.24" />
      <rect x="114.71" y="235.84" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="146.51" y="358.45" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="79.24" y="77.52" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="148.96" y="260.84" rx="5" ry="5" width="15.86" height="94.01" />
      <rect x="273.7" y="43" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="178.31" y="325.12" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="238.24" y="226.32" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="282.26" y="356.06" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="123.27" y="185.84" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="272.48" y="215.6" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="260.25" y="189.41" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="493.84" y="164.42" rx="5" ry="5" width="18.3" height="114.24" />
      <rect x="623.2" y="239.41" rx="5" ry="5" width="18.3" height="171.36" />
      <rect x="502.12" y="323.93" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="466.94" y="219.17" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="535.43" y="129.9" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="377.66" y="252.5" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="344.64" y="220.36" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="343.41" y="257.26" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="306.72" y="225.13" rx="5" ry="5" width="18.3" height="114.24" />
      <rect x="76.8" y="419.15" rx="5" ry="5" width="18.3" height="114.24" />
      <rect x="106.15" y="439.39" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="133.06" y="422.73" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="360.54" y="420.34" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="141.62" y="462.01" rx="5" ry="5" width="18.3" height="171.36" />
      <rect x="174.64" y="456.06" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="192.98" y="487" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="399.67" y="451.29" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="199.1" y="527.48" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="230.9" y="516.76" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="230.9" y="556.05" rx="4" ry="4" width="212.28" height="22.61" />
      <rect x="447.37" y="482.24" rx="5" ry="5" width="17.08" height="94.01" />
      <rect x="320.18" y="485.81" rx="4" ry="4" width="111.02" height="22.61" />
      <rect x="514.64" y="454.86" rx="5" ry="5" width="18.3" height="171.36" />
      <rect x="233.34" y="586.99" rx="4" ry="4" width="111.02" height="22.61" />
    </content-loader>
  </div>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'WordCloudLoader',
  components: {
    ContentLoader,
  },
};
</script>



// WEBPACK FOOTER //
// WordCloudLoader.vue?777a77b3